export default "__VITE_ASSET__dEokQ8bt__"